/*
*   This lib should be used for as an interface towards using LocalStorage.
*   Transformation to and from JSON object should be done here.
*   Usage rules:
*   (1) if you are getting (reading) anything, this library shall return an object.
*   (2) if you are setting (writing) anything, this library shall accept objects.
*   (3) any nested object should be handled in an external JS file.
*   (4) in case of blocked storage, it need to be caught at an higher instance.
*   (5) you should not need to touch this class at all.
*
*   Setting item: You only need to specify the key for the feature (one key
*   per feature) and the value (most likely an object containing all the features
*   values). It works similar to our reducers.
*
*   Getting item: You will get the whole object for the given featureKey. If it
*   does not exist it will generate one.
*
*   Naming conventions:
*   - jibberObject: the whole jibber object.
*   - jibberStorage: the JSON (string).
*
*   Example:
*   jibber-dash: {
*       [feature1]: {
*           [feature1key]: feature1Val
*       },
*       [myFeature]: {
*           [myFeatureKey]: myFeatureVal
*       }
*   }
*/

const jibberKey = 'jibber-dash'

class LocalStorage {
    static write(featureKey, value) {
        const storageObject = JSON.parse(this._readRaw())
        let featureObject = this.read(featureKey)
        featureObject = value
        storageObject[featureKey] = featureObject
        window.localStorage.setItem(jibberKey, JSON.stringify(storageObject))
    }


    static _readRaw() {
        let jibberStorage = window.localStorage.getItem(jibberKey)
        if (!jibberStorage) {
            const jibberObject = {}
            window.localStorage.setItem(jibberKey, JSON.stringify(jibberObject))
        }
        return window.localStorage.getItem(jibberKey)
    }


    static read(featureKey) {
        const jibberStorage = this._readRaw()
        let jibberObject = JSON.parse(jibberStorage)
        if (!(featureKey in jibberObject)) {
            jibberObject[featureKey] = {}
            window.localStorage.setItem(jibberKey, JSON.stringify(jibberObject))
            return jibberObject[featureKey]
        }
        return jibberObject[featureKey]
    }
}

export default LocalStorage



// WEBPACK FOOTER //
// ./src/lib/LocalStorage/LocalStorage.js